<template>
  <div :class="$style.deviceRow">
    <div :class="$style.selectWrapper">
      <Select
        name="device operator"
        :options="options"
        placeholder="Select Operator"
        :rules="rules"
        :value="model.status"
        @input="(newStatus) => setAttribute('status', newStatus)"
      />
    </div>

    <div :class="$style.selectWrapper">
      <InputText
        v-model="deviceValue"
        isDisabled
      />
    </div>
  </div>
</template>

<script>
import { InputText, Select } from '@jumpcloud/ui-components';
import { find } from 'lodash';
import { mapGetters } from 'vuex';

import { ConditionInclusion, ExpressionStatus } from 'client/Security/data/Condition';
import ConditionDevice from 'client/Security/data/ConditionDevice';
import ConditionDeviceEncrypted from 'client/Security/data/ConditionDeviceEncrypted';

export default {
  name: 'ConditionRowDevice',

  components: {
    InputText,
    Select,
  },

  props: {
    value: {
      type: ConditionDevice,
      default: () => new ConditionDevice(),
    },
  },

  data() {
    return {
      deviceValue: 'JumpCloud managed',

      model: null,

      options: [
        { name: 'Is', value: ExpressionStatus.include },
        { name: 'Is Not', value: ExpressionStatus.exclude },
      ],
    };
  },

  computed: {
    ...mapGetters('AuthNPolicyModel', [
      'item',
    ]),

    rules() {
      const diskEncryptionConditionExists = !!find(
        this.item.conditions.expressions,
        item => item instanceof ConditionDeviceEncrypted,
      );
      const includeAll = this.item.conditions.inclusion === ConditionInclusion.all;

      return `required|unmanagedDeviceCondition:${diskEncryptionConditionExists},${includeAll}`;
    },
  },

  beforeMount() {
    this.model = this.value;

    this.$emit('input', this.model);
  },

  methods: {
    setAttribute(key, value) {
      this.model[key] = value;

      this.$emit('input', this.model);
    },
  },
};
</script>

<style module>
.deviceRow {
  display: grid;
  gap: 1em;
  grid-template-columns: 1fr 1fr;
}

.selectWrapper {
  --input-wrapper-width: auto;
  --input-wrapper-min-width: 10ch;
}
</style>
